import { render, staticRenderFns } from "./SxLogin.vue?vue&type=template&id=1d028cff&scoped=true&"
import script from "./SxLogin.vue?vue&type=script&lang=js&"
export * from "./SxLogin.vue?vue&type=script&lang=js&"
import style0 from "./SxLogin.vue?vue&type=style&index=0&id=1d028cff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d028cff",
  null
  
)

export default component.exports